
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./edc.cjs.production.min.js')
} else {
  module.exports = require('./edc.cjs.development.js')
}
